/**
 * Use this class to correct the prototype chain.
 * https://github.com/Microsoft/TypeScript/issues/13965
 */
export abstract class GenericError extends Error {
  public constructor(message?: string) {
    const trueProto = new.target.prototype;
    super(message);
    Object.setPrototypeOf(this, trueProto);
  }
}

export class HttpResponseError extends GenericError {
  public readonly status: number;

  public constructor(status: number) {
    super(`Request failed with status ${status}`);
    this.status = status;
  }
}
